import { useMemo } from 'react';

import { Action, ResourceType, useHasPermission } from '../../../../../shared/permissions';

/**
 * Hook for managing aaaaaalllll the various permissions for managing teams.
 *
 * @param {number} teamId - The ID of the team to check permissions for.
 */
const useTeamPermissions = (teamId: number) => {
  const hasPermission = useHasPermission();

  return useMemo(() => ({
    canViewAnyTeam: hasPermission({ action: Action.View, resourceType: ResourceType.TeamAny }),
    canEditAnyTeam: hasPermission({ action: Action.Edit, resourceType: ResourceType.TeamAny }),
    canDeleteAnyTeam: hasPermission({ action: Action.Delete, resourceType: ResourceType.TeamAny }),
    canCreateTeam: hasPermission({ action: Action.Create, resourceType: ResourceType.Team }),
    canViewThisTeam: hasPermission({ action: Action.View, resourceType: ResourceType.Team, teamId }),
    canEditThisTeam: hasPermission({ action: Action.Edit, resourceType: ResourceType.Team, teamId }),
  }), [hasPermission, teamId]);
};

export default useTeamPermissions;
